<template>
  <div
    class="tw-border-b-[0.5px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-flex tw-items-center tw-justify-between tw-pl-[65px] tw-pr-[25px] tw-text-[12px] tw-font-medium tw-py-3 tw-gap-2"
  >
    <p
      :class="`${!data.headingDetails ? 'tw-text-[10px]' : ''} ${
        noIndex ? 'tw-pl-[30px]' : ''
      } tw-m-0`"
      :style="`padding-left: ${data.level * 30}px`"
    >
      {{ noIndex ? "" : index + 1 + "." }}
      {{
        data.categoryName ||
        (data.headingLabel
          ? data.headingLabel
          : getComponentUiText(
              "app-component-assessments-input-question-other-1",
            ))
      }}
    </p>
    <div class="tw-flex tw-items-center tw-justify-center tw-gap-[100px]">
      <div
        class="tw-w-[20px] tw-flex tw-items-center tw-justify-center tw-text-[#878787]"
        :class="data.headingItemCount ? 'tw-text-[10px]' : ''"
      >
        {{ data.categoryCount || data.headingItemCount }}
      </div>

      <ArrowDownTableIcon
        v-if="data.headingDetails"
        :color="'#ccc'"
        :class="[data.id === idItemExpland ? 'show' : '', 'tw-cursor-pointer']"
        @click="idItemExpland = idItemExpland === data.id ? null : data.id"
      />
      <div v-else class="tw-w-[11px]"></div>
    </div>
  </div>
  <hr class="tw-w-full tw-my-0 tw-border-[#eff0f1]" />

  <div
    v-if="data.headingDetails && data.id === idItemExpland"
    class="tw-w-full tw-text-[10px]"
  >
    <ManageTemplateCatergoryItem
      v-for="item in data.headingDetails"
      :key="item.id"
      :data="item"
      :no-index="true"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import { getComponentUiText } from "@/utils/utilities";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: false,
    default: 0,
  },
  noIndex: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const idItemExpland: any = ref(null);

const emit = defineEmits([]);
</script>

<style lang="scss" scoped>
.show {
  transform: rotate(180deg);
}
.title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 16.9px */
  margin-right: 4px;
}
.score-title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.content__settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Poppins;
  line-height: 135%;
  cursor: pointer;
}

.border-bottom {
  border-bottom: 1px solid #eff0f1;
}
</style>
